import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useMemo, useRef } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
export function useMemoFromPropsDerivative(factory, propsDerivator, props) {
  // cache the last set of props
  var prev = useRef(props);
  var prevFactory = useRef(null);
  return useMemo(function () {
    var init = propsDerivator(props);
    if (fg('cc_complexit_fe_reduce_fragment_serialization')) {
      // check if the serializer is already created
      var shouldCreate = !prevFactory.current;
      // check each prop to see if value has changed and also check if the number of props has changed
      if (prev.current !== props) {
        // @ts-ignore - error TS2769: No overload matches this call.
        var propsEntries = Object.entries(props);
        // Break these into its own const to skip TS checks.
        // @ts-ignore - error TS2769: No overload matches this call.
        var isLengthDifferent = propsEntries.length !== Object.keys(prev.current).length;
        // @ts-ignore
        var isValueDifferent = propsEntries.some(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            prop = _ref2[1];
          return prev.current[key] !== prop;
        });
        shouldCreate = isLengthDifferent || isValueDifferent;
      }
      prev.current = props;
      // If first time or any prop value has changed, create a new serializer
      if (shouldCreate) {
        prevFactory.current = factory(init);
      }
    }

    // If progressive rendering is enabled, create a new serializer
    if (fg('cc_complexit_fe_progressive_adf_rendering')) {
      var _props$createSerializ;
      // @ts-ignore - erorr TS2339 Property 'createSerializer' does not exist on type 'Props'.
      var newSerializer = (_props$createSerializ = props.createSerializer) === null || _props$createSerializ === void 0 ? void 0 : _props$createSerializ.call(props, init);
      if (newSerializer) {
        return newSerializer;
      }
    }
    return fg('cc_complexit_fe_reduce_fragment_serialization') ? prevFactory.current : factory(init);
  },
  // To keep deps consistent, here disable the exhaustive-deps rule to drop factory from the deps array
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [propsDerivator, props]);
}